module.exports = __webpack_public_path__ + "img/3fb151946665dd12ac16776202da90f4.png";